var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#0089fb;stroke-miterlimit:10;stroke-width:1.64px;}.cls-2{fill:#0089fb;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-.48,23.92h31.33s.04.02.04.04v1.58c0,.6-.48,1.08-1.08,1.08H.55c-.59,0-1.08-.48-1.08-1.08v-1.59s.02-.04.04-.04Z",
    transform: "translate(40.46 10.09) rotate(90)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.01,9.57h3.15v2.71h-3.15c-.75,0-1.35-.61-1.35-1.35h0c0-.75.61-1.35,1.35-1.35Z",
    transform: "translate(35.82 21.84) rotate(-180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.01,38.27h3.15v2.71h-3.15c-.75,0-1.35-.61-1.35-1.35h0c0-.75.61-1.35,1.35-1.35Z",
    transform: "translate(35.82 79.25) rotate(-180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.53,25.27h20.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.99,25.27h12.52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.06,26.81c-.85,0-1.54-.69-1.54-1.54s.69-1.54,1.54-1.54,1.54.69,1.54,1.54-.69,1.54-1.54,1.54Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.21 25.27 30.76 29.13 33 25.27 30.76 21.41 40.21 25.27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c0ccb2aed37d104f3b9e02fa870547a3.svg";
export { ForwardRef as ReactComponent };